import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=5e0a5470"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"
import style0 from "./Projects.vue?vue&type=style&index=0&id=5e0a5470&prod&lang=css"
import style1 from "./Projects.vue?vue&type=style&index=1&id=5e0a5470&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports